import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/buon-trap.png'


const _withScopeId = n => (_pushScopeId("data-v-85e2ebe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Trang chủ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Trang chủ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "section-intro" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row d-flex align-items-center min-vh-100" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col col-12 col-lg-7 text-center text-lg-start py-5" }, [
        /*#__PURE__*/_createElementVNode("div", {
          style: {"background-color":"rgba(255, 255, 255, .7)"},
          class: "py-4 px-5"
        }, [
          /*#__PURE__*/_createElementVNode("h6", { class: "main-color" }, "Thông tin, giải trí, văn hoá"),
          /*#__PURE__*/_createElementVNode("h3", null, "Buôn Trấp - Krông Ana - Đắk Lắk"),
          /*#__PURE__*/_createElementVNode("div", null, [
            /*#__PURE__*/_createElementVNode("p", null, "Trước năm 1975, vùng này thuộc thị xã Buôn Ma Thuột, tỉnh Đắk Lắk, chỉ có ba buôn người Êđê là Buôn Trấp nằm gần sát bờ Sông Serepôk, sau này gọi là sông Krông Ana, 2 buôn còn lại là Ê Căm và Rung nằm gần nhau.")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col col-12 col-lg-5 text-center py-5" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          class: "mw-100",
          style: {"width":"350px"}
        })
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ion-hide-lg-up",
        translucent: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, {
            class: "ion-hide-lg-up",
            collapse: "condense"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}